<template>
  <div class="flex layout-column elevation-0 pa-1" style="border-radius: 6px;overflow-y: hidden"
       :style="{'background': compColor.lxExpansion.background}">

    <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center layout-row pb-2 pt-0" v-if="canEdit">
      <lx-btn small classes="mr-1" :disabled="false"
              @click="getDiagnoses()"
              :color="compColor.primeColor"
              :iconColor="'white'"
              :height="35"
              iconSize="21"
              icon="refresh" :tooltip="$t('buttons.refresh.title')" :label="$t('buttons.refresh.value')"
              :hide-label="true"></lx-btn>
      <lx-btn icon="add_circle"
              :color="compColor.primeColor"
              :iconColor="'white'"
              :tooltip="$t('COMPONENT_DOCUMENTATION.ADD_NEW_DIAGNOSIS')"
              :label="$t('COMPONENT_DOCUMENTATION.ADD_NEW_DIAGNOSIS')"
              iconSize="21"
              :width="'auto'"
              :height="35"
              classes="text-none"
              @click="showNewDiagnosisDialog=true"
      ></lx-btn>

      <div class="flex"></div>

      <div class="layout-row layout-align-center mr-3"
           style="height:35px;">
        <span class="flex px-3 death_report_span"
              style="cursor:pointer;"
              @click="showDeathReport=true"
              :class="[ !deathForm._id ? 'deathFormBorder': '', 'legend-color-' + getColorOfDeathReportForm()]">
          {{ formatTextOfDeathForm() }}</span>

        <div class="px-1 death_report_menu">
          <v-menu
            bottom
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                :title="$t('buttons.edit_create.title_btn_group')"
                :color="'#546e7a'"
              >
                mdi-menu-open
              </v-icon>
            </template>
            <v-btn-toggle
              dense
              name="toggleDeathReport"
              :dark="isDarkMode"
            >
              <v-btn @click="showDeathReport=true" :title="$t('buttons.edit_create.title')">
                <v-icon :color="'#546e7a'">mdi-pencil</v-icon>
              </v-btn>
              <v-btn @click="setIgnoredForReport" :disabled="!deathForm._id || deathForm.formStatus === 'sent' || deathForm.formStatus === 'ignoredForReport'" :title="$t('buttons.ignoreForImport.value')">
                <v-icon :color="'#546e7a'">mdi-card-bulleted-off</v-icon>
              </v-btn>
              <v-btn @click="openDeleteDialogDeathForm" :disabled="!deathForm._id || deathForm.formStatus === 'sent'" :title="$t('buttons.delete.title')">
                <v-icon :color="'#546e7a'">delete_forever</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-menu>
        </div>
      </div>

      <v-tooltip bottom open-delay="1000">
        <template v-slot:activator="{ on }">
          <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-center px-3"
               style="cursor: pointer;">
            <v-icon :color="compColor.prime" medium>info</v-icon>
            <span class="ml-2 body-2" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.LABEL_INFO_STATUS_COLOR') }}</span>
          </div>
        </template>
        <legend-table></legend-table>
      </v-tooltip>
    </div>

    <div class="flex layout-column">
      <lx-data-table-simple
        tableName="DiagnosesList"
        v-model="tableObj.selection"
        :items="diagnosisItems"
        :headers="tableObj.headers"
        :loading="tableObj.loading"
        :preventRowClick="true"
        :no-data-text="$t('AG_GRID.NO_ROWS')"
        :hideContextFilter="true"
        :autoGrow="canEdit"
        :tableOptions="tableObj.options"
        :setHeightOnItems="!canEdit">

        <template v-slot:cellrenderer="{ value }">

          <div v-if="value.f.renderer === 'legend'"
               style="padding:2px;height:35px;"
               :style="{'cursor': canEdit ? 'pointer' : 'default'}"
               @click="showFormSingle(value.i, value.i.forms[value.f.renderparams.key],value.f.renderparams.key)">
            <div class="layout-row layout-align-center-center" style="border-radius:3px;height:31px;" v-if="value.i.forms[value.f.renderparams.key]" :class="['legend-color-'+value.i.forms[value.f.renderparams.key].color]">
              <v-avatar color="#ffffffaa" size="24" v-if="value.i.forms[value.f.renderparams.key].subFormCount > 0">
                <span class="body-2 font-weight-bold blue-grey--text">{{ value.i.forms[value.f.renderparams.key].subFormCount }}</span>
              </v-avatar>
            </div>
          </div>

          <div v-if="value.f.renderer === 'localization'" class="layout-align-center-start">
            <span>{{ getFieldValue(value.i.localization, 'SeitenlokalisationTypesShort') }}</span>
          </div>

          <div v-if="value.f.renderer === 'delete' && showDeleteOption(value.i)"
               style="cursor:pointer;"
               class="layout-align-center-start">
            <v-icon :color="compColor.primeColor" @click="openDeleteDialog(value.i)">mdi-delete-forever</v-icon>
          </div>
        </template>
      </lx-data-table-simple>
    </div>

    <!-- death report dialog -->

    <new-diagnosis-dialog
      :showNewDiagnosisDialog="showNewDiagnosisDialog"
      :patientId="patientId"
      :deathForm="deathForm"
      @close-diagnosis-dialog="closeDialog('showNewDiagnosisDialog')">
    </new-diagnosis-dialog>

    <!-- death report dialog -->

    <death-report-dialog
      :showDeathReportDialog="showDeathReport"
      :diagnoses="diagnosesListForDeathReport"
      :formId="deathForm._id"
      :patientId="patientId"
      @close-death-report-dialog="closeDialog('showDeathReport')">
    </death-report-dialog>
  </div>
</template>

<script>
import utils from '../../common/utils'
import lodash from 'lodash'

import legendTable from '../../components/legend_table/legendTable'
import deathReportDialog from './DeathReportDialog.vue'
import newDiagnosisDialog from './NewDiagnosisDialog.vue'

export default {
  name: 'DiagnosesList',
  props: ['patientId', 'canEdit', 'tabid'],
  mixins: [utils],
  components: {
    legendTable,
    deathReportDialog,
    newDiagnosisDialog
  },
  data () {
    return {
      loading: false,
      showIt: true,
      showNewDiagnosisDialog: false,
      showDeathReport: false,
      diagnosisItems: [],
      deathForm: {},
      diagnosesListForDeathReport: [],
      count: 0,
      forms: [],
      tableObj: {
        loading: false, // benutzt während des GetData, um eine Ladeanimation einzublenden
        options: {
          sortBy: [],
          sortDesc: [],
        },
        selection: null,
        headers: [
          {
            text: '',
            width: '50px',
            renderer: 'delete'
          },
          {
            text: this.$t('LIST_DIVERSE.DIAG_ID'),
            value: 'subj_id',
            width: '105px'
          },
          {
            text: this.$t('FORMS_DIVERSE.ICD_CODE_SHORT'),
            value: 'diag_code',
            width: '80px'
          },
          {
            text: this.$t('FORMS_DIVERSE.ICD_CODE_DATE'),
            value: 'diag_date',
            width: '115px',
            renderer: 'date'
          },
          {
            text: this.$t('FORMS_DIVERSE.ICD_CODE_SIDE_LOCALIZATION'),
            value: 'localization',
            width: '140px',
            renderer: 'localization'
          }
        ]
      },
      deleteDialogTitle: this.$t('CONFIRM_DELETE_DIALOG.HEADER'),
      deleteDialogMessage: this.$t('CONFIRM_DELETE_DIALOG.MESSAGE_DELETE_FORM'),
      deleteDialogOpts: {
        ok: this.$t('buttons.delete.value'),
        cancel: this.$t('buttons.cancel.value')
      }
    }
  },
  created () {
    this.$eventBus.on('reload-after-form-update-' + this.patientId, this.getDiagnoses, this.$route?.params?.tabid)

    const self = this
    // add forms dynamic to table, necessary for table body
    this.$store.getters.getformsMetadata.forEach(function (category) {
      self.forms.push(category)
    })

    if (!this.canEdit) {
      this.tableObj.headers.splice(0, 1)
    }

    this.createTableHeaders()
    this.getDiagnoses()
  },
  destroyed () {
    this.$eventBus.remove('reload-after-form-update-' + this.patientId, this.$route?.params?.tabid)
  },
  methods: {
    /**
     * Close death report dialog
     */
    closeDialog (dialog) {
      this[dialog] = false
    },

    /**
     *  Show or hide trash-icon to delete diagnosis
     *
     * @param value The row-value of diagnoses-list
     * @returns {boolean}
     */
    showDeleteOption (value) {
      const forms = value.forms || {}

      return this.count > 1 && Object.keys(forms).length === 1 && forms.register && forms.register.color !== 'blue' && !(forms.register.last_report && forms.register.last_report.meldung_id)
    },

    /**
     * Open popup to give user possibility to decide if diagnosis is really to be deleted
     *
     * @param value The row value of diagnoses-list
     */
    openDeleteDialog (value) {
      this.DialogConfirm(
        this.deleteDialogTitle,
        this.deleteDialogMessage,
        this.deleteDialogOpts)
        .then(() => {
          this.deleteDiagnosis(value)
        })
        .catch(() => {
        })
    },

    /**
     * Open popup to give user possibility to decide if deathForm is really to be deleted
     *
     */
    openDeleteDialogDeathForm () {
      this.DialogConfirm(
        this.deleteDialogTitle,
        this.deleteDialogMessage,
        this.deleteDialogOpts)
        .then(() => {
          this.deleteDeathForm()
        })
        .catch(() => {
        })
    },

    /**
     * Delete selected existing death form
     */
    deleteDeathForm () {
      this.$http.delete('/documentation/form/' + this.deathForm._id)
        .then((res) => {
          this.getDiagnoses()
          this.NotifySuccess(res, this.$t('FORMS_DIVERSE.MESSAGE_SUCCESSFULLY_DELETE'))
        })
        .catch(this.NotifyError)
    },

    /**
     * Set form on ignored for report
     */
    setIgnoredForReport () {
      if (this.deathForm._id && this.deathForm.formStatus !== 'sent') {
        this.$http.patch('/documentation/formStatus/ignoredForReport/' + this.deathForm._id)
          .then(() => {
            this.$nextTick(() => {
              // reload of patient
              this.getDiagnoses()
            })
          })
          .catch(this.NotifyError)
      }
    },

    /**
     * Delete selected diagnosis after agreeing in popup
     *
     * @param value The row value of diagnoses-list
     */
    deleteDiagnosis (value) {
      if (!this.loading && value.forms && value.forms.register && value.forms.register._id) {
        this.loading = true

        this.$http.delete('/documentation/form/' + value.forms.register._id)
          .then(() => {
            this.loading = false
            this.getDiagnoses()
          })
          .catch(error => {
            this.loading = false
            this.NotifyError(error)
          })
      }
    },

    /**
     * Set Color in list in dependency to state of death report form
     */
    getColorOfDeathReportForm () {
      if (this.deathForm) {
        switch (this.deathForm.formStatus) {
          case 'sent':
            return 'blue'
          case 'ignoredForReport':
            return 'grey'
          case 'completed':
            return 'green'
          default:
            return this.deathForm._id ? 'yellow' : 'white'
        }
      } else {
        return 'white'
      }
    },

    /**
     * Format text of death form in diagnosis list, contains date of death and linked diagnosis
     *
     * @returns {string}
     */
    formatTextOfDeathForm () {
      if (this.deathForm?._id) {
        let text = 'Tod: ' + this.$options.filters['formatDate'](this.deathForm.base.sterbedatum, 'DD.MM.YYYY')
        const diagnosis = this.diagnosisItems.find(item => item.diag_id === this.deathForm.register_form_id)

        if (diagnosis && diagnosis.diag_code && diagnosis.diag_date) {
          text += ' (' + diagnosis.diag_code + ' - ' + this.$options.filters['formatDate'](diagnosis.diag_date, 'DD.MM.YYYY') + ')'
        }

        return text
      } else {
        return 'Keine Todesmeldung erstellt'
      }
    },

    /**
     * Add spaces to title in table to get columns with same width
     *
     * @param title
     * @returns {*}
     */
    returnItemTitleForTable (title) {
      if (title === this.$t('forms.systemicTherapy')) title = 'Syst. Therapie'
      let diff = 16 - (title || '').length

      // add spaces till title has 20 characters
      for (let i = 0; i < diff; i++) {
        title += ' \xA0'
      }

      return title
    },

    /**
     * Create header of table dynamically in dependency to forms
     */
    createTableHeaders () {
      const self = this

      this.forms.forEach(function (item) {
        const navItem = {
          text: self.returnItemTitleForTable(item.title),
          value: 'forms.' + item.key + '.subFormCount',
          bodyClass: 'pa-0',
          renderer: 'legend',
          renderparams: {
            key: item.key
          }
        }

        self.tableObj.headers.push(navItem)
      })
    },

    /**
     * Open detail view with diagnosis and selected form
     *
     * @param base The base data of diagnosis
     * @param item The selected form
     * @param key The key of selected form
     */
    showFormSingle (base, item, key) {
      if (!this.canEdit) {
        return
      }

      const baseData = {
        diagCode: base.diag_code,
        diagDate: base.diag_date,
        subjId: base.subj_id,
        localization: base.localization,
        patientId: this.patientId
      }

      if (this.deathForm?.base?.sterbedatum) {
        baseData.deathDate = this.deathForm.base.sterbedatum
      }

      if (base.forms && base.forms.register) {
        baseData.registerId = base.forms.register._id
      }

      this.$store.dispatch('setDiagnosisBaseInformation', baseData)
      this.$store.dispatch('setActualSubjID', { patient: this.patientId, subjId: base.subj_id })

      this.$emit('input', { form: item, key: key, baseData: baseData })
    },

    /**
     * Get all diagnoses of selected patient from db
     */
    getDiagnoses () {
      let config = {
        opts: {
          sort: { 'Diagnose.Diagnosedatum': -1, subj_id: -1 }
        },
        query: {
          patient_id: this.patientId
        }
      }

      this.$http.get('/documentation/getOverview?config=' + JSON.stringify(config))
        .then(res => {
          if (res.data) {
            this.$set(this, 'diagnosisItems', res.data.diagnosisItems || [])
            this.$set(this, 'count', res.data.count)
            this.$set(this, 'deathForm', res.data.deathForm || {})

            if (res?.data?.deathFormStatus) {
              this.$set(this.deathForm, 'formStatus', res.data.deathFormStatus)
            }

            this.diagnosesListForDeathReport = lodash.cloneDeep(this.diagnosisItems)
            this.diagnosesListForDeathReport.forEach(item => {
              delete item.forms
            })

            // route to selected invalid death-form from report dialog
            const storedPatient = this.$store.getters.routingAfterReportValidation(this.patientId)

            if (storedPatient && storedPatient.showFormData && storedPatient.formDetails && storedPatient.formDetails.key === 'death') {
              this.showDeathReport = true
            }
          }
          this.loading = false
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.loading = false
        })
    }
  },

  watch: {
    '$route' (to) {
      if (to?.path === '/patient/details/' + this.tabid + '/' + this.patientId) {
        this.getDiagnoses()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.death_report_span {
  font-size: 15px;
  padding-top: 6px;
  color: #546e7a;
  border-radius: 4px 0 0 4px;
}

.death_report_menu {
  padding-top: 4px;
  background-color: lightgrey;
  border-radius: 0 4px 4px 0;
}

.deathFormBorder {
  border-bottom: 2px solid lightgrey !important;
  border-top: 2px solid lightgrey !important;
  border-left: 2px solid lightgrey !important;
}
</style>
